import type { Chain } from "viem/chains";
import * as _SUPPORTED_CHAINS from "viem/chains";

import { getEntries } from "@/util/core";

const SUPPORTED_CHAINS = {
  ..._SUPPORTED_CHAINS,
};

export const { CHAINID_MAP, CHAINKEY_MAP } = getEntries(
  _SUPPORTED_CHAINS,
).reduce<{
  CHAINID_MAP: Record<number, Chain>;
  CHAINKEY_MAP: Record<number, string>;
}>(
  ({ CHAINID_MAP, CHAINKEY_MAP }, [key, value]) => {
    // @ts-ignore
    const id = value?.id;

    if (!id || !Number.isFinite(id)) {
      return { CHAINID_MAP, CHAINKEY_MAP };
    }

    return {
      CHAINID_MAP: { ...CHAINID_MAP, [id]: value },
      CHAINKEY_MAP: { ...CHAINKEY_MAP, [id]: key },
    };
  },
  { CHAINID_MAP: {}, CHAINKEY_MAP: {} },
);

export { SUPPORTED_CHAINS };

/** @deprecated move to env */
export const DEFAULT_CHAIN: keyof typeof SUPPORTED_CHAINS = "mainnet";
